import React, { useState } from 'react'
import { usePage } from '@inertiajs/react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import StorefrontIcon from '@mui/icons-material/Storefront'
import type { SharedProps } from '@/types'

interface Props {
  children: React.ReactNode
  title: string
}

export default function AuthLayout({ children, title }: Props) {
  const { props } = usePage<SharedProps>()
  const { flash } = props
  const [flashOpen, setFlashOpen] = useState(true)

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <StorefrontIcon sx={{ fontSize: 48, color: 'primary.main', mb: 1 }} />
          <Typography variant="h4" fontWeight={700} color="primary">
            Okonomi App Store
          </Typography>
        </Box>
        <Paper elevation={2} sx={{ p: 4 }}>
          <Typography variant="h5" component="h1" gutterBottom textAlign="center">
            {title}
          </Typography>
          {children}
        </Paper>
      </Container>

      {flash.notice && (
        <Snackbar open={flashOpen} autoHideDuration={6000} onClose={() => setFlashOpen(false)}>
          <Alert severity="success" onClose={() => setFlashOpen(false)}>
            {flash.notice}
          </Alert>
        </Snackbar>
      )}
      {flash.alert && (
        <Snackbar open={flashOpen} autoHideDuration={6000} onClose={() => setFlashOpen(false)}>
          <Alert severity="error" onClose={() => setFlashOpen(false)}>
            {flash.alert}
          </Alert>
        </Snackbar>
      )}
    </Box>
  )
}
